import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams, anyToHash } from "utils/misc";

export default function useAdminLogs(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAdminLogs() {
      setLoading(true);
      const { response, data } = await API.admin.fetchLogs(token, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      } else {
        console.error(data);
      }
    }

    fetchAdminLogs();
  }, [token, anyToHash(filters)]);

  return {
    loading,
    logs: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
